module.exports = __webpack_public_path__ + "img/crew5_7-8-2021.d6fa3c15.jpg";